<template>
    <div>
        <v-data-table id="actActionsTable" :headers="headers" :items="items" hide-default-footer disable-pagination disable-sort disable-filtering>
            <template v-slot:item.serv_type_name="{ item }">
                <div>
                    <div class="pb-4">{{ item.serv_type_name }}</div>
                    <v-btn :disabled="items.length === 1 || item.is_connected" @click="deleteServiceAct(item)" small rounded outlined color="gray"
                        >Удалить из акта</v-btn
                    >
                </div>
            </template>
            <template v-slot:item.is_connected="{ item }">
                <div>
                    <div :class="item['is_connected'] ? 'success--text' : 'warning--text'">
                        {{ item['is_connected'] ? 'Подключено' : 'Отключено' }}
                    </div>
                    <div style="color: #666">{{ item['action_date'] }}</div>
                </div>
            </template>
            <template v-slot:item.reason="{ item }">
                <div class="select">
                    <v-select
                        :disabled="abonentDebt && item.act_action_type_rid != 3"
                        v-model="item['reason_rid']"
                        hide-details
                        outlined
                        color="primaryDark"
                        label="Выбрать"
                        :items="acts_reasons(item.act_action_type_rid)"
                        item-text="reason_name"
                        item-value="record_id"
                        :rules="[validationRules.required]"
                    />
                </div>
            </template>
            <template v-slot:item.act="{ item }">
                <v-radio-group :rules="[validationRules.required_action_type]" v-model="item['act_action_type_rid']">
                    <v-radio
                        :disabled="disabledActionOnDebt(item['act_action_type_rid'])"
                        color="gray"
                        v-for="actionType of actions"
                        :key="actionType['record_id']"
                        :label="actionType.action_name"
                        :value="actionType.record_id"
                    />
                </v-radio-group>
            </template>
        </v-data-table>
        <v-btn @click="addServiceAct()" v-if="this.isContract" :disabled="disabledAddService()" small color="gray" outlined class="mr-3">
            <v-icon>mdi-plus</v-icon>
        </v-btn>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import translate from '@/utils/translate.util';
import { validationRules } from '@/utils/validationRules';

export default {
    name: 'actActionsTable',
    props: ['items', 'abonentDebt', 'isContract'],
    inject: ['deleteService', 'addService'],
    data: function() {
        return {
            headers: [
                {
                    text: 'Услуга',
                    value: 'serv_type_name',
                    width: 208
                },
                {
                    text: 'Состояние',
                    value: 'is_connected',
                    width: 160
                },
                {
                    text: 'Причина',
                    value: 'reason',
                    width: 280
                },
                {
                    text: 'Действие',
                    value: 'act'
                }
            ]
        };
    },
    computed: {
        validationRules() {
            return validationRules;
        },
        ...mapGetters('refs', ['getReasonsList', 'getActionsList']),
        reasons() {
            return translate(this.getReasonsList, 'full', this.$i18n.locale);
        },
        actions() {
            return translate(this.getActionsList, 'full', this.$i18n.locale);
        }
    },
    methods: {
        deleteServiceAct(item) {
            this.deleteService(item);
        },
        addServiceAct() {
            this.addService();
        },
        disabledActionOnDebt(val) {
            if (this.abonentDebt && val === 1 && this.items.filter(c => c.act_action_type_rid === 1).length === 1) {
                return true;
            }
            return false;
        },
        acts_reasons(act_action_type_rid) {
            return this.reasons.filter(x => (act_action_type_rid == 3 && [81, 83, 84].includes(x.record_id)) || act_action_type_rid != 3 || !this.isContract);
        },
        disabledAddService() {
            if (this.items) return this.items.length === 4;
            return false;
        }
    }
};
</script>

<style lang="scss">
#actActionsTable tbody {
    tr:hover {
        background-color: transparent !important;
    }
}
.select {
    width: 250px;
}
</style>
